import { useCallback } from 'react';

import { matchPath } from 'react-router';

import { ROUTE_PATHS } from '@/shared/config/router/types';

import {
  FULL_SCREEN_PAGES,
  MAX_PATH_DEPTH_TO_SHOW_NAVBAR,
  RELATIVE_PATHNAMES,
} from '../constants';
import { type NavbarRoute } from '../types';

export const useIsActiveRoute = (pathname: string) => {
  return useCallback(
    (route: NavbarRoute) => {
      if (pathname === ROUTE_PATHS.WHEEL && route === ROUTE_PATHS.TASKS) return true;

      const pathParts = pathname.split('/').filter(Boolean);
      const depth = pathParts.length + 1;

      if (depth > MAX_PATH_DEPTH_TO_SHOW_NAVBAR) return false;
      if (FULL_SCREEN_PAGES.some((p) => pathParts.includes(p))) return false;

      const end =
        route === ROUTE_PATHS.MAIN && !RELATIVE_PATHNAMES.includes(pathParts[0]);

      return !!matchPath({ path: route, end }, pathname);
    },
    [pathname]
  );
};
